const ENABLED_VALUES = new Set(['1', 'true', 'yes', 'on'])

export function parseFeatureFlag(value?: string): boolean {
  return ENABLED_VALUES.has(value?.trim().toLowerCase() ?? '')
}
